import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { get_serializableProperties1162nosnaangd as get_serializableProperties } from './SerializableProperty.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  nullElement39ujy5fzowmto as nullElement,
  LazySerialDescriptor3enjj1xzeog28 as LazySerialDescriptor,
} from './SerializationHelpers.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { GenericPlaceholderSerializer267m3qun4y50l as GenericPlaceholderSerializer } from './SerializationRegistry.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { get_elementNamesl5b6t976dltd as get_elementNames } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptor.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { Partial3s6az7bcg7e88 as Partial } from './Partial.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function _get_childSerializers__7vnyfa($this) {
  var tmp0 = $this.childSerializers$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('childSerializers', 1, tmp, PartialSerializer$_get_childSerializers_$ref_w8t6cm(), null);
  return tmp0.get_value_j01efc_k$();
}
function _get_innerDescriptor__gn4218($this) {
  var tmp0 = $this.innerDescriptor$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('innerDescriptor', 1, tmp, PartialSerializer$_get_innerDescriptor_$ref_rjrmfq(), null);
  return tmp0.get_value_j01efc_k$();
}
function PartialSerializer$_get_childSerializers_$ref_w8t6cm() {
  return constructCallableReference((p0) => _get_childSerializers__7vnyfa(p0), 1, 0, 143);
}
function PartialSerializer$innerDescriptor$delegate$lambda$lambda$lambda(it) {
  return it.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
}
function PartialSerializer$_get_innerDescriptor_$ref_rjrmfq() {
  return constructCallableReference((p0) => _get_innerDescriptor__gn4218(p0), 1, 0, 144);
}
var PartialSerializerClass;
function PartialSerializer() {
  if (PartialSerializerClass === VOID) {
    class $ {
      constructor(source) {
        this.source_1 = source;
        var tmp = this;
        tmp.childSerializers$delegate_1 = lazy(() => {
          var tmp0_safe_receiver = get_serializableProperties(this.source_1);
          var tmp;
          if (tmp0_safe_receiver == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(tmp0_safe_receiver.length);
            var inductionVariable = 0;
            var last = tmp0_safe_receiver.length;
            while (inductionVariable < last) {
              var item = tmp0_safe_receiver[inductionVariable];
              inductionVariable = inductionVariable + 1 | 0;
              var tmp_0;
              if (item.get_serializer_u29zhh_k$().get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$()) {
                var nn = ensureNotNull(nullElement(item.get_serializer_u29zhh_k$()));
                var tmp_1;
                if (!(get_serializableProperties(nn) == null) && !nn.get_descriptor_wjt6a0_k$().get_isInline_usk17w_k$()) {
                  tmp_1 = equals(nn, this.source_1) ? get_nullable(this) : get_nullable(new (PartialSerializer())(nn));
                } else {
                  tmp_1 = item.get_serializer_u29zhh_k$();
                }
                tmp_0 = tmp_1;
              } else {
                var tmp_2;
                if (!(get_serializableProperties(item.get_serializer_u29zhh_k$()) == null) && !item.get_serializer_u29zhh_k$().get_descriptor_wjt6a0_k$().get_isInline_usk17w_k$()) {
                  tmp_2 = equals(item.get_serializer_u29zhh_k$(), this.source_1) ? this : new (PartialSerializer())(item.get_serializer_u29zhh_k$());
                } else {
                  tmp_2 = item.get_serializer_u29zhh_k$();
                }
                tmp_0 = tmp_2;
              }
              var tmp$ret$2 = tmp_0;
              destination.add_utx5q5_k$(tmp$ret$2);
            }
            tmp = destination;
          }
          var tmp1_elvis_lhs = tmp;
          var tmp_3;
          if (tmp1_elvis_lhs == null) {
            var tmp_4;
            var tmp_5;
            if (this.source_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() === 'kotlin.Nothing') {
              tmp_5 = true;
            } else {
              var tmp_6 = this.source_1;
              tmp_5 = tmp_6 instanceof GenericPlaceholderSerializer();
            }
            if (tmp_5) {
              // Inline function 'kotlin.collections.listOf' call
              tmp_4 = emptyList();
            } else {
              throw IllegalArgumentException().new_kotlin_IllegalArgumentException_sfqr8_k$('Failed to make partial serializer: ' + this.source_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + ' has no serializableProperties');
            }
            tmp_3 = tmp_4;
          } else {
            tmp_3 = tmp1_elvis_lhs;
          }
          return tmp_3;
        });
        var tmp_0 = this;
        tmp_0.innerDescriptor$delegate_1 = lazy(() => {
          var tmp;
          try {
            var sourceDescriptor = this.source_1.get_descriptor_wjt6a0_k$();
            tmp = buildClassSerialDescriptor('com.lightningkite.services.database.Partial', [sourceDescriptor], ($this$buildClassSerialDescriptor) => {
              var tmp;
              if (!(sourceDescriptor.get_elementsCount_288r0x_k$() === _get_childSerializers__7vnyfa(this).get_size_woubt6_k$())) {
                var tmp_0 = sourceDescriptor.get_elementsCount_288r0x_k$();
                var tmp_1 = _get_childSerializers__7vnyfa(this).get_size_woubt6_k$();
                var tmp_2 = joinToString(get_elementNames(sourceDescriptor));
                var tmp_3 = _get_childSerializers__7vnyfa(this);
                throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Mismatch in child serializer count; ' + tmp_0 + ' vs ' + tmp_1 + '; ' + tmp_2 + ' vs ' + joinToString(tmp_3, VOID, VOID, VOID, VOID, VOID, PartialSerializer$innerDescriptor$delegate$lambda$lambda$lambda));
              }
              var inductionVariable = 0;
              var last = sourceDescriptor.get_elementsCount_288r0x_k$();
              var tmp_4;
              if (inductionVariable < last) {
                do {
                  var index = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  var s = _get_childSerializers__7vnyfa(this).get_c1px32_k$(index);
                  if (s instanceof PartialSerializer()) {
                    $this$buildClassSerialDescriptor.element_om879h_k$(sourceDescriptor.getElementName_u4sqmf_k$(index), s.descriptor_1, sourceDescriptor.getElementAnnotations_omrjs6_k$(index), true);
                  } else {
                    $this$buildClassSerialDescriptor.element_om879h_k$(sourceDescriptor.getElementName_u4sqmf_k$(index), sourceDescriptor.getElementDescriptor_ncda77_k$(index), sourceDescriptor.getElementAnnotations_omrjs6_k$(index), true);
                  }
                }
                 while (inductionVariable < last);
                tmp_4 = Unit_instance;
              }
              return Unit_instance;
            });
          } catch ($p) {
            var tmp_0;
            if ($p instanceof Exception()) {
              var e = $p;
              throw Exception().new_kotlin_Exception_9qyiel_k$('Failed to make partial descriptor for ' + this.source_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$(), e);
            } else {
              throw $p;
            }
          }
          return tmp;
        });
        var tmp_1 = this;
        var tmp_2 = CLASS_getInstance();
        tmp_1.descriptor_1 = new (LazySerialDescriptor())('com.lightningkite.services.database.Partial', tmp_2, VOID, () => _get_innerDescriptor__gn4218(this));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.descriptor_1;
        var composite = decoder.beginStructure_yljocp_k$(descriptor);
        var out = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        $l$loop_0: while (true) {
          var index = composite.decodeElementIndex_bstkhp_k$(this.descriptor_1);
          switch (index) {
            case -1:
              break $l$loop_0;
            case -3:
              continue $l$loop_0;
            default:
              // Inline function 'kotlin.collections.find' call

              var tmp0 = ensureNotNull(get_serializableProperties(this.source_1));
              var tmp$ret$3;
              $l$block: {
                // Inline function 'kotlin.collections.firstOrNull' call
                var inductionVariable = 0;
                var last = tmp0.length;
                while (inductionVariable < last) {
                  var element = tmp0[inductionVariable];
                  inductionVariable = inductionVariable + 1 | 0;
                  if (element.get_name_woqyms_k$() === this.descriptor_1.getElementName_u4sqmf_k$(index)) {
                    tmp$ret$3 = element;
                    break $l$block;
                  }
                }
                tmp$ret$3 = null;
              }

              var tmp$ret$2 = tmp$ret$3;
              var tmp2 = ensureNotNull(tmp$ret$2);
              // Inline function 'kotlin.collections.set' call

              var value = composite.decodeSerializableElement$default_j0zaoi_k$(this.descriptor_1, index, _get_childSerializers__7vnyfa(this).get_c1px32_k$(index));
              out.put_4fpzoq_k$(tmp2, value);
              break;
          }
        }
        var result = new (Partial())(out);
        composite.endStructure_1xqz0n_k$(descriptor);
        return result;
      }
      serialize_84vsl_k$(encoder, value) {
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.descriptor_1;
        var composite = encoder.beginStructure_yljocp_k$(descriptor);
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = value.parts_1.get_entries_p20ztl_k$().iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var _destruct__k2r9zo = _iterator__ex2g4s.next_20eer_k$();
          // Inline function 'kotlin.collections.component1' call
          var key = _destruct__k2r9zo.get_key_18j28a_k$();
          // Inline function 'kotlin.collections.component2' call
          var v = _destruct__k2r9zo.get_value_j01efc_k$();
          var index = this.descriptor_1.getElementIndex_utfbym_k$(key.get_name_woqyms_k$());
          var tmp = _get_childSerializers__7vnyfa(this).get_c1px32_k$(index);
          composite.encodeSerializableElement_isqxcl_k$(this.descriptor_1, index, isInterface(tmp, KSerializer()) ? tmp : THROW_CCE(), v);
        }
        composite.endStructure_1xqz0n_k$(descriptor);
        return Unit_instance;
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_84vsl_k$(encoder, value instanceof Partial() ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, 'PartialSerializer', VOID, VOID, [KSerializer()]);
    PartialSerializerClass = $;
  }
  return PartialSerializerClass;
}
//region block: exports
export {
  PartialSerializer as PartialSerializer3a1dmo3dlumfz,
};
//endregion

//# sourceMappingURL=PartialSerializer.mjs.map
